const strengthsJSON = {
  section: 'SAW',
  topic: 'Strengths and Challenges',
  checked: 'true',
  color: 'secondary',
  description: '(optional)',
  body: [
    {
      id: 'SAW.1',
      shortname: 'saw1',
      mandatory: 'true',
      name: 'In my opinion I have the following personal strengths and positive personality characteristics:',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'text',
      act: 'SAW1',
      depending: '',
      exception: '',
      extend: '',
      link: '',
    },
    {
      id: 'SAW.2',
      shortname: 'saw2',
      mandatory: 'true',
      name: 'In my opinion I have the following personal challenges and negative personality characteristics:',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'text',
      act: 'SAW2',
      depending: '',
      exception: '',
      extend: '',
      link: '',
    },
    // {
    //   id: "SAW.3",
    //   access: "private",
    //   shortname: "saw3",
    //   mandatory: "true",
    //   name: "In this evaluator's opinion this patient has the following personal strengths and positive characteristics. Document individual's strengths, preferences, extracurricular, community and social activities, extended family; activities that the individual engages in or are meaningful to the individual. These elements are key to developing an ISP that supports the individual’s recovery and resiliency efforts and goals.",
    //   prevalue: "",
    //   value: "",
    //   disabled: "false",
    //   type: "text",
    //   act: "SAW3",
    //   depending: "",
    //   exception: "",
    //   extend: "",
    //   link: ""
    // },
    {
      id: 'SAW.3',
      shortname: 'saw3-vir',
      name: "In this evaluator's opinion this patient has the following personal strengths and positive characteristics. Document individual's strengths, preferences, extracurricular, community and social activities, extended family; activities that the individual engages in or are meaningful to the individual. These elements are key to developing an ISP that supports the individual's recovery and resiliency efforts and goals.",
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'subtopic',
      act: 'SAW3-VIR',
      depending: '',
      exception: '',
    },
    {
      id: 'SAW.3',
      shortname: 'saw3-left',
      name: '',
      prevalue: '',
      disabled: 'false',
      value: [],
      type: 'checkbox',
      radio_options: [
        'Capable of Independence',
        'Insightful',
        'Reliable',
        'Responsible',
        'Physical Health',
        'Integrated Moral Values',
        'Motivated',
        'Confident',
        'Positive Support Network',
        'Communication',
        'Organization',
      ],
      act: 'SAW3-LEFT',
      depending: '',
      exception: '',
      subtopic_container_act: 'SAW3-VIR',
      suptopic_code: 'SAW3-VIR-LEFT',
      subtopic_name: '',
    },
    {
      id: 'SAW.3',
      shortname: 'saw3-right',
      name: '',
      prevalue: '',
      disabled: 'false',
      value: [],
      type: 'checkbox',
      radio_options: [
        'Supportive Family',
        'Accepts Guidance/Feedback',
        'Reasonable Judgement',
        'Varied Interest',
        'Clear Thinking',
        'Good Personal Care Habits',
        'Expressive/Articulate',
        'Sociable',
        'Critical Thinking',
        'Other',
      ],
      act: 'SAW3-RIGHT',
      depending: '',
      exception: '',
      link:"SAW3-RIGHT-OTHER",
      subtopic_container_act: 'SAW3-VIR',
      suptopic_code: 'SAW3-VIR-RIGHT',
      subtopic_name: '',
    },
    {
      id: "SAW.3",
      extend: "true",
      shortname: "saw3-right-other",
      name: "",
      prevalue: "Please, explain:",
      value: "",
      disabled: "true",
      type: "text",
      act: "SAW3-RIGHT-OTHER",
      depending: "SAW3-RIGHT",
      exception: "Other",
      subtopic_container_act: 'SAW3-VIR',
      suptopic_code: 'SAW3-VIR-RIGHT',
      subtopic_name: '',
    },
    {
      id: 'SAW.4',
      access: 'private',
      shortname: 'saw4',
      mandatory: 'true',
      name: "In this evaluator's opinion this patient has the following personal challenges and negative personality characteristics:",
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'text',
      act: 'SAW4',
      depending: '',
      exception: '',
      extend: '',
      link: '',
    },
    {
      id: 'SAW.5',
      shortname: 'saw5-1-vir',
      name: "Identify Client's Cognitive Functioning Strengths & Weaknesses :",
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'text',
      act: 'SAW5-1-VIR',
      mandatory: 'true',
      depending: '',
      exception: '',
    },
    {
      id: 'SAW.6',
      access: 'private',
      shortname: 'saw6-vir',
      mandatory: 'true',
      name: "What is this client's ability to access services?",
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'text',
      act: 'SAW6-VIR',
      depending: '',
      exception: '',
      extend: '',
      link: '',
    },
    {
      id: 'SAW.7',
      shortname: 'mse9-vir',
      name: 'FUNCTIONAL IMPAIRMENTS: Counselor checks all that apply.',
      prevalue: '',
      value: '',
      disabled: 'false',
      type: 'subtopic',
      act: 'MSE9-VIR',
      depending: '',
      exception: '',
    },
    {
      id: 'SAW.7.1',
      shortname: 'mse9-1-vir',
      name: '',
      prevalue: 'Difficulty concentrating, completing tasks, or meeting deadlines at work or school.',
      value: [false, false, false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact N/A', 'Current with 30 Days', 'Previously'],
      act: 'MSE9-1-VIR',
      depending: '',
      exception: '',
      subtopic_container_act: 'MSE9-VIR',
      suptopic_code: 'OCCUPATIONAL_OR_ACADEMIC_FUNCTIONING_TAB_VIR',
      subtopic_name: 'Occupational or Academic Functioning',
    },
    {
      id: 'SAW.7.2',
      shortname: 'mse9-2-vir',
      name: '',
      prevalue:
        'Strained relationships with family, friends, or colleagues due to social withdrawal, conflict, or communication problems.',
      value: [false, false, false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact N/A', 'Current with 30 Days', 'Previously'],
      act: 'MSE9-2-VIR',
      depending: '',
      exception: '',
      subtopic_container_act: 'MSE9-VIR',
      suptopic_code: 'INTERPERSONAL_RELATIONSHIPS_TAB_VIR',
      subtopic_name: 'Interpersonal Relationships',
    },
    {
      id: 'SAW.7.3',
      shortname: 'mse9-3-vir',
      name: '',
      prevalue: "Struggles with ADL's such as laundry, hygiene and budgeting.",
      value: [false, false, false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact N/A', 'Current with 30 Days', 'Previously'],
      act: 'MSE9-3-VIR',
      depending: '',
      exception: '',
      subtopic_container_act: 'MSE9-VIR',
      suptopic_code: 'SELF_CARE_DAILY_LIVING_TAB_VIR',
      subtopic_name: 'Self-Care and Daily Living Activities',
    },
    {
      id: 'SAW.7.4',
      shortname: 'mse9-4-vir',
      name: '',
      prevalue: 'Difficulty managing emotions such as anxiety, depression, anger, or impulsivity.',
      value: [false, false, false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact N/A', 'Current with 30 Days', 'Previously'],
      act: 'MSE9-4-VIR',
      depending: '',
      exception: '',
      subtopic_container_act: 'MSE9-VIR',
      suptopic_code: 'EMOTIONAL_REGULATION_TAB_VIR',
      subtopic_name: 'Emotional Regulation',
    },
    {
      id: 'SAW.7.5',
      shortname: 'mse9-5-vir',
      name: '',
      prevalue: 'Impaired cognitive abilities such as memory, decision-making, or problem-solving.',
      value: [false, false, false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact N/A', 'Current with 30 Days', 'Previously'],
      act: 'MSE9-5-VIR',
      depending: '',
      exception: '',
      subtopic_container_act: 'MSE9-VIR',
      suptopic_code: 'COGNITIVE_FUNCTIONING_TAB_VIR',
      subtopic_name: 'Cognitive Functioning',
    },
    {
      id: 'SAW.7.6',
      shortname: 'mse9-6-vir',
      name: '',
      prevalue: '',
      value: [false, false, false],
      disabled: 'false',
      type: 'checkbox',
      radio_options: ['Impact N/A', 'Current with 30 Days', 'Previously'],
      act: 'MSE9-6-VIR',
      depending: '',
      exception: '',
      subtopic_container_act: 'MSE9-VIR',
      suptopic_code: 'CULTURAL_SPIRITUAL_RECREATIONAL_TAB_VIR',
      subtopic_name: 'Cultural/Spiritual/Recreational History',
    },
  ],
};

export default strengthsJSON;
